import type { LinearFn2d } from ".."
import type { Edge2dComputed } from "../../mesh"

export const getSlopeOfEdge = (edge: Edge2dComputed): number => {
  const { p1, p2 } = edge
  const dx = p2.x - p1.x
  const dy = p2.y - p1.y
  const slope = dy / dx

  return Math.abs(slope) > Number.MAX_SAFE_INTEGER / 1000 ? Infinity : slope
}

export const edgeToLinearFn = (edge: Edge2dComputed): LinearFn2d => {
  const slope = getSlopeOfEdge(edge)
  const { p1 } = edge
  const intercept = p1.y - slope * p1.x
  const fn = (x: number) => slope * x + intercept
  fn.slope = slope
  fn.intercept = intercept

  return fn
}

export interface LinearFnWithInverse extends LinearFn2d {
  inverse: LinearFn2d
}

export const edgeToLinearFnWithInverse = (
  edge: Edge2dComputed,
): LinearFnWithInverse => {
  const linearFn = edgeToLinearFn(edge)
  const inverse = (y: number) => (y - linearFn.intercept) / linearFn.slope
  inverse.slope = 1 / linearFn.slope
  inverse.intercept = -linearFn.intercept / linearFn.slope
  const withInverse = Object.assign(linearFn, { inverse })

  return withInverse
}
